export const INTERPRETING_PARTICLE_TAG = '[口译稿]';

export type InterpretingStimulus = {
  title: string;
  basicEnglish: string;
  chinese: string;
};

function normalizeTaggedSourceText(text: string | null | undefined): string {
  return String(text || '')
    .trim()
    .replace(/［/g, '[')
    .replace(/］/g, ']')
    .replace(/【/g, '[')
    .replace(/】/g, ']');
}

export function isInterpretingTaggedText(text: string | null | undefined): boolean {
  const normalized = normalizeTaggedSourceText(text);
  if (!normalized) {
    return false;
  }
  return normalized.startsWith(INTERPRETING_PARTICLE_TAG)
    || /(^|\n)\s*\[Basic English\]/i.test(normalized);
}

function sliceBetween(source: string, start: RegExp, end: RegExp): string {
  const startMatch = source.match(start);
  if (!startMatch || startMatch.index == null) {
    return '';
  }
  const from = startMatch.index + startMatch[0].length;
  const rest = source.slice(from);
  const endIndex = rest.search(end);
  return (endIndex < 0 ? rest : rest.slice(0, endIndex)).trim();
}

export function parseInterpretingStimulus(text: string | null | undefined): InterpretingStimulus | null {
  const normalized = normalizeTaggedSourceText(text);
  if (!isInterpretingTaggedText(normalized)) {
    return null;
  }

  const withoutTag = normalized.replace(/^\[口译稿\]\s*/, '').trim();
  const basicIndex = withoutTag.search(/\[Basic English\]/i);
  if (basicIndex < 0) {
    return {
      title: withoutTag.split('\n')[0]?.trim() || '',
      basicEnglish: withoutTag,
      chinese: '',
    };
  }

  return {
    title: withoutTag.slice(0, basicIndex).trim(),
    basicEnglish: sliceBetween(withoutTag, /\[Basic English\]\s*/i, /\[中文\]/),
    chinese: sliceBetween(withoutTag, /\[中文\]\s*/, /\[Basic English\]/i),
  };
}

export function isInterpretingParticle(...sources: Array<string | null | undefined>): boolean {
  return sources.some((source) => isInterpretingTaggedText(source));
}
